import { render, staticRenderFns } from "./index.vue?vue&type=template&id=678cb318&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=678cb318&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678cb318",
  null
  
)

/* custom blocks */
import block0 from "../locale/ivestor-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fivestor%2Findex.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "../locale/ivestor-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fivestor%2Findex.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Decorator: require('/vercel/path0/components/ui/decorator.vue').default,IvestorAppStoreLinks: require('/vercel/path0/components/blocks/ivestorAppStoreLinks.vue').default,PageHeroLarge: require('/vercel/path0/components/PageHeroLarge.vue').default,CImage: require('/vercel/path0/components/ui/c-image.vue').default,CardWithImageBg: require('/vercel/path0/components/ui/CardWithImageBg.vue').default,VideoThumbnailCard: require('/vercel/path0/components/ui/VideoThumbnailCard.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default,FaqsAccordionMulti: require('/vercel/path0/components/datablocks/FaqsAccordionMulti.vue').default})
